export const GET_VISUAL_BUILDER_DATA = "GET_VISUAL_BUILDER_DATA";
export const UPDATE_VISUAL_BUILDER_DATA = "UPDATE_VISUAL_BUILDER_DATA";
export const RESET_VISUAL_BUILDER_DATA = "RESET_VISUAL_BUILDER_DATA";
